import Modal from '@/components/Modal/Modal';
import { FC } from 'react';
import Button, { ButtonSizes, ButtonVariants } from '@/components/new-design/Button';
import { twMerge } from 'tailwind-merge';

interface ConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onClickConfirm: () => void;
  message: string;
  confirmText: string;
  cancelText: string;
}

const ConfirmationModal: FC<ConfirmationModalProps> = ({
  open,
  onClose,
  onClickConfirm,
  message,
  confirmText,
  cancelText,
}) => {
  const buttonClasses =
    'rounded-full flex justify-center items-center font-bold text-white hover:text-ph-secondary-portage text-sm mt-2';
  return (
    <Modal open={open} setClose={onClose}>
      <div className="flex flex-col items-center justify-center gap-8">
        <span className="text-lg font-semibold text-white">{message}</span>
        <div className="flex gap-4 text-[16px]">
          <Button
            id="modal-confirm-button"
            onClick={onClickConfirm}
            size={ButtonSizes.xl}
            variant={ButtonVariants.transparentWithBorder}
            className={twMerge(buttonClasses, 'hover:border-ph-red hover:text-ph-red')}
          >
            {confirmText}
          </Button>
          <Button
            id="modal-cancel-button"
            onClick={onClose}
            variant={ButtonVariants.transparentWithBorder}
            className={twMerge(buttonClasses, 'hover:border-ph-secondary-portage')}
          >
            {cancelText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
